import { ServicePageTemplate } from "@/components/ServicePageTemplate";

export default function Haushaltsaufloesung() {
  return (
    <ServicePageTemplate
      service={{
        title: "Haushaltsauflösung",
        keyword: "Haushaltsauflösung Berlin",
        metaTitle:
          "Haushaltsauflösung Berlin | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Einfühlsame und professionelle Haushaltsauflösung in Berlin. Alles aus einer Hand, mit Wertanrechnung und Festpreisgarantie.",
        heroSub:
          "Komplette Räumung aus einer Hand – respektvoll, strukturiert und garantiert besenrein.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a109a1ab49dc13ffb.jpg",
        trustImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a9017ae7d4768390653f4.jpg",
        seoImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a90167249909712123538.jpg",
        faqImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/6a3a901a659bec99fc9f3e99.jpg",
        trustIntro:
          "Einen kompletten Haushalt aufzulösen, ist emotional und körperlich anstrengend. Oft hängt Zeitdruck im Nacken, weil die Wohnung übergeben werden muss. Als Familienbetrieb verstehen wir diese Belastung. Wir kümmern uns um jedes Detail, von der Sortierung bis zur Schlüsselübergabe.",
        slug: "haushaltsaufloesung-berlin",
        showOurWork: true,
      }}
    />
  );
}
